module.exports = __webpack_public_path__ + "static/media/icon-check-failed.7128897e.svg";